/* eslint-disable no-else-return */
/* eslint-disable no-underscore-dangle */
import axios from 'axios'
import endpoints from 'services/endpoints'
import { USER_TOKEN_REFRESH_SUCCESS } from 'redux/actions/actionTypes'
import { logInReset } from 'redux/actions/login'
import { getDeviceId } from './utils'
import { store } from './configureStore'

const deviceId = getDeviceId()

axios.interceptors.request.use(
  config => {
    const {
      user: { accessToken },
      settings: { locale }
    } = store.getState()

    if (accessToken && config.url.indexOf("/auth/refreshSession") === -1 && config.url.indexOf("/auth/createSession") === -1) {
      config.headers.Authorization = `Bearer ${accessToken}`
    } else {
      config.headers.Authorization = ""
    }

    config.headers['Accept-Language'] = locale
    config.headers['Device-Id'] = deviceId

    return config
  },
  err => {
    return Promise.reject(err)
  },
)

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error)
    } else {
      prom.resolve(token)
    }
  })

  failedQueue = []
}

axios.interceptors.response.use(
  response => response,
  (error) => {
    const originalRequest = error.config

    // reset auth data if token refresh failed
    if (error.response.status === 401 && error.request.responseURL.indexOf("/auth/refreshSession") !== -1) {
      store.dispatch(logInReset())
    }

    if (error.response.data && error.response.data.error.indexOf("token is expired") !== -1 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })
        })
          .then(token => {
            originalRequest.headers.Authorization = `Bearer ${token}`
            return axios(originalRequest)
          })
          .catch(err => {
            return Promise.reject(err)
          })
      }

      originalRequest._retry = true
      isRefreshing = true

      const { user: { refreshToken } } = store.getState()

      return new Promise((resolve, reject) => {
        axios
          .post(endpoints.sessionRefresh, { refreshToken })
          .then(({ data }) => {
            const { accessToken, refreshToken } = data;
            store.dispatch({ type: USER_TOKEN_REFRESH_SUCCESS, data: { accessToken, refreshToken } })

            axios.defaults.headers.common.Authorization = `Bearer ${data.token}`
            originalRequest.headers.Authorization = `Bearer ${data.token}`
            processQueue(null, data.token)
            resolve(axios(originalRequest))
          })
          .catch(err => {
            processQueue(err, null)
            reject(err)
          })
          .then(() => {
            isRefreshing = false
          })
      })
    }

    // reset auth data if returned 401 excepting login & logout request
    if ((error.response.status === 401) && error.request.responseURL.indexOf("/auth/") === -1) {
      store.dispatch(logInReset())
    }

    return Promise.reject(error)
  },
)
